var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shareLocationButtonContainer"}},[_c('el-button',{attrs:{"id":"shareLocationButton","round":""},on:{"click":_vm.updateShareLocationStatus}},[_c('div',{attrs:{"id":"shareLocationText"}},[_vm._v(_vm._s(_vm.shareLocationText))]),_c('div',{attrs:{"id":"shareLocationSubText"}},[_vm._v(_vm._s(_vm.shareLocationSubText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }